import { createAction, createReducer } from "@reduxjs/toolkit";
import { isFunction } from "lodash-es";

export const getActionNameString = (actionName) => {
  // ActionName must be a valid string or ActionCreator function
  if (!actionName) {
    return "";
  } else if (isFunction(actionName.toString)) {
    return actionName.toString();
  } else if (typeof actionName === "string") {
    return actionName;
  }

  return "";
}

export const INVALID_ACTION_TYPE_ERROR = "Invalid value for action name. Value provided must be an ActionCreator function or string";

const Actions = {
  setActionLoaderTrue: "setActionLoaderTrue",
  setActionLoaderFalse: "setActionLoaderFalse"
};

// Actions
export const setActionLoaderTrue = createAction(Actions.setActionLoaderTrue);
export const setActionLoaderFalse = createAction(Actions.setActionLoaderFalse);

// Selectors
export const getActionLoader = (state, actionName) => {
  const actionNameString = getActionNameString(actionName);

  if (actionNameString) {
    return state.actionLoader[actionNameString] || false;
  } else {
    throw new Error(INVALID_ACTION_TYPE_ERROR);
  }
}

const initialState = {};

export default createReducer(initialState, (builder) => {
  builder.addCase(setActionLoaderTrue, (state, action) => {
    const actionName = action.payload;

    const actionNameString = getActionNameString(actionName);
    
    if (!actionNameString) {
      throw new Error(INVALID_ACTION_TYPE_ERROR);
    }

    state[actionNameString] = true;
  });
  builder.addCase(setActionLoaderFalse, (state, action) => {
    const actionName = action.payload;

    const actionNameString = getActionNameString(actionName);

    if (!actionNameString) {
      throw new Error(INVALID_ACTION_TYPE_ERROR);
    }

    delete state[actionNameString];
  })
})